import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=6e09b47e&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=6e09b47e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e09b47e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e09b47e')) {
      api.createRecord('6e09b47e', component.options)
    } else {
      api.reload('6e09b47e', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=6e09b47e&scoped=true&", function () {
      api.rerender('6e09b47e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2uF5OhO5PjGL6/JS/comp/PopupBox.vue"
export default component.exports